'use client';

import { useEffect } from 'react';
import { useDigitalCardState } from 'src/components/_common/DigitalCard/_hooks/useDigitalCard';
import styled from 'styled-components';

const HologramEffect = () => {
  const { cardRef, isAllResourcesLoaded, isInteracting } = useDigitalCardState();

  useEffect(() => {
    if (!cardRef?.current) return;
    if (isInteracting) return;

    setTimeout(() => {
      if (!cardRef?.current) return;
      cardRef.current.style.setProperty('--light-x', '50%');
      cardRef.current.style.setProperty('--light-y', '50%');
    }, 100);
  }, [cardRef, isInteracting]);

  if (!isAllResourcesLoaded) return null;

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <Container>
        <StyledRadialGradientEffect />
        <StyledHologramEffect />
      </Container>
    </div>
  );
};

export default HologramEffect;

export const Container = styled.div`
  mask-image: url('https://cdn.kottonseed.io/assets/football/fcseoul/my-collection/digital-card/training/hologram/hologram_mask.jpg');
  -webkit-mask-image: url('https://cdn.kottonseed.io/assets/football/fcseoul/my-collection/digital-card/training/hologram/hologram_mask.jpg');
  mask-size: cover;
  -webkit-mask-size: cover;
  mask-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-position: center;
  mask-mode: luminance;
  -webkit-mask-mode: luminance;
  mask-type: luminance;
  -webkit-mask-type: luminance;

  position: relative;
  width: 100%;
  height: 100%;
`;

export const StyledRadialGradientEffect = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;

  /* 기존 radial 빛 효과 */
  background: radial-gradient(
    farthest-corner circle at var(--light-x, 50%) var(--light-y, 50%),
    hsla(0, 0%, 80%, 0.8) 10%,
    hsla(0, 0%, 80%, 0.65) 20%,
    hsla(0, 0%, 0%, 0.5) 90%
  );

  filter: brightness(0.4) contrast(1.5);
  mix-blend-mode: overlay;
`;

export const StyledHologramEffect = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;

  background-image: url('https://cdn.kottonseed.io/assets/football/fcseoul/my-collection/digital-card/training/hologram/hologram.png');
  /* background-size: cover; */
  background-position: center;
  background-repeat: repeat;

  /* 배경 돌리기 */
  background-size:
    150% 150%,
    200% 200%,
    200% 200%;
  background-position:
    calc(var(--light-x, 50%)) calc(var(--light-y, 50%)),
    calc(var(--light-x, 50%)) calc(var(--light-y, 50%)),
    calc(var(--light-x, 50%)) calc(var(--light-y, 50%));

  background-blend-mode: overlay;

  filter: brightness(1.1) contrast(1.1) saturate(1.2);
  mix-blend-mode: color-dodge;
  transition:
    background-position 0.1s linear,
    filter 0.1s linear;
`;
